import { ErrorWalletView } from './ErrorWallet.view'

export interface IErrorWalletProps {
  badChainId?: boolean
}

export const ErrorWallet = ({ badChainId }: IErrorWalletProps) => {
  return <ErrorWalletView badChainId={badChainId} />
}
